import {installSafeWebStorage} from "@/lib/browserStorage";

if (typeof window !== "undefined") {
    installSafeWebStorage();
}
